import { NICmsContentField } from '@icms/core/content';
import { ICmsContentService } from '@icms/core/content/icms-content.service';
import { ALLOWED_UTMS, TUtm } from '../../module/gtm/utm';

export const CMS_CONFIG_PRODUCT = 'product';

export interface ICmsConfigProductDataContent {
    templateRules?: IProductTemplateRule[];
}

export interface IProductTemplateRule {
    template: string;
    utm: IProductTemplateRuleUtm[];
}

export interface IProductTemplateRuleUtm {
    key: TUtm;
    value: string;
}

ICmsContentService.registerConfig({
    id: CMS_CONFIG_PRODUCT,
    name: 'Product Page Configuration',
    fields: [
        <NICmsContentField.IRepeaterField>{
            key: 'templateRules',
            type: NICmsContentField.EFieldType.repeater,
            title: 'Template Rules',
            itemName: 'Template Rule',
            itemNameField: 'template',
            fields: [
                <NICmsContentField.IChoiceField>{
                    key: 'template',
                    type: NICmsContentField.EFieldType.choice,
                    title: 'Template',
                    options: [
                        {
                            key: 'google',
                            title: 'Google'
                        }
                    ]
                },
                <NICmsContentField.IRepeaterField>{
                    key: 'utm',
                    type: NICmsContentField.EFieldType.repeater,
                    title: 'URL parameters',
                    itemName: 'Parameter',
                    itemNameField: 'key',
                    fields: [
                        <NICmsContentField.IChoiceField>{
                            key: 'key',
                            type: NICmsContentField.EFieldType.choice,
                            title: 'Parameter',
                            options: ALLOWED_UTMS.map(utm => {
                                const title = utm.slice(4);

                                return {
                                    key: utm,
                                    title: `UTM ${title[0].toUpperCase()}${title.slice(1)}`
                                };
                            })
                        },
                        <NICmsContentField.ITextField>{
                            key: 'value',
                            type: NICmsContentField.EFieldType.text,
                            title: 'Value'
                        }
                    ]
                }
            ]
        }
    ]
});
